import React, { useState } from 'react';
import logo from '../../../Assets/images/Logo/logo.png';
import BgImage from '../../../Assets/images/BgImage/number_background.png';
import Preview from '../../../Assets/images/LandingPageImage/preview.png';
import BeginnersGuide from './LandingComponents/Buttons/BeginnersGuide';
import GooglePlayButton from './LandingComponents/Buttons/GoogleStoreButton';
import AppStoreButton from './LandingComponents/Buttons/AppleStoreButton';
import SocialLinks from './SocialLinks';
import CopyrightFooter from './CopyRightFooter';
import TutorialButton from './LandingComponents/Buttons/TutorialsButton';
import KnowledgeBot from './LandingComponents/KnowledgeBot/UI';
import '../../../Assets/styles/LandingStyles/Footer.css';
import '../../../Assets/styles/LandingStyles/MobileLanding.css';
import CookieConsentLanding from './CookieBanner/CookieConsentLanding';
import { useLanguage } from '../../../Core/Translations/LanguageContext';
import { LanguageSelector } from '../../../Core/Translations/LanguageSelector';
import PromotionsNotification from '../Promotions/Promotions';
import DiscordButton from './DiscordButton';


const MobileLanding: React.FC = () => {
    const [showBot, setShowBot] = useState(false);
    const { t, language } = useLanguage();

    const toggleBot = () => {
        setShowBot(!showBot);
    };

    return (
        <div className="mobile-App">
            {/* HEADER */}
            <header className="mobile-header">
                <div className="header-left-section">
                    <img src={logo} alt="Sudoku VS Logo" className="logo" style={{ borderRadius: '50%' }} />
                    <PromotionsNotification />
                </div>
                <div className="tutorial_button_container">
                    <TutorialButton text={t.header.tutorialButton} />
                </div>
                        <LanguageSelector theme="light" dropdownDirection='down' />
            </header>
            
            {/* GRADIENT */}
            <div className="mobile-gradient" />
            
            {/* MAIN CONTENT */}
            <div className="mobile-main-container">
                {/* Preview section */}
                <div className="mobile-preview-section">
                    <div
                        className="mobile-bg-container mobile-clip-slanted"
                        style={{ backgroundImage: `url(${BgImage})` }}
                    />
                    <div className="mobile-preview-container">
                        <img
                            src={Preview}
                            alt="Sudoku VS Preview"
                            className="mobile-preview-image"
                        />
                    </div>
                </div>
                
                {/* CTA section */}
                <div className="mobile-content-section">
                    <h1 className="mobile-heading">{t.hero.title}</h1>
                    <p className="mobile-paragraph">
                        <strong>{t.hero.description}</strong>
                    </p>
                </div>
                
                {/* Buttons section */}
                <div className="mobile-buttons-container">
                    <BeginnersGuide text={t.beginnersGuide.modalTitle} />
                    <GooglePlayButton text={t.hero.googlePlay} />
                    <AppStoreButton text={t.hero.appStore} />
                    
                    {/* Bot Toggle Button - Conditionally rendered temporarily commented until back is back up
                    {language === 'en' && (
                        <button 
                            onClick={toggleBot}
                            className="mobile-bot-toggle-button"
                            style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '12px 20px',
                                borderRadius: '25px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                transition: 'all 0.3s ease',
                                margin: '10px 0',
                                width: '100%',
                                maxWidth: '280px'
                            }}
                            onTouchStart={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
                            }}
                            onTouchEnd={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                            }}
                        >
                            🤖 {showBot ? t.hero.botButtonHide : t.hero.botButtonShow}
                        </button>
                    )}*/}
                </div>
                
                {/* Social Media section */}
                <div className="mobile-social-section">
                    <p className="mobile-follow-us-text">{t.footer.followUs}</p>
                    <SocialLinks />
                    <p className="mobile-handle">{t.footer.handle}</p>
                        <DiscordButton text={t.hero.discordButton || "Join our Discord"} />

                </div>
                <CopyrightFooter />
            </div>

            {/* Bot Modal/Overlay - Mobile optimized */}
            {showBot && (
                <div 
                    className="mobile-bot-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        padding: '10px',
                        paddingTop: '20px'
                    }}
                    onClick={(e) => {
                        // Close bot when clicking outside
                        if (e.target === e.currentTarget) {
                            setShowBot(false);
                        }
                    }}
                >
                    <div 
                        className="mobile-bot-container"
                        style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: '400px',
                            height: 'calc(100vh - 40px)',
                            maxHeight: '650px',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setShowBot(false)}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'rgba(255, 255, 255, 0.9)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                color: '#666',
                                zIndex: 1001,
                                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                transition: 'all 0.3s ease'
                            }}
                            onTouchStart={(e) => {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                                e.currentTarget.style.color = '#333';
                            }}
                            onTouchEnd={(e) => {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                                e.currentTarget.style.color = '#666';
                            }}
                        >
                            ×
                        </button>
                        
                        {/* Bot Component - Add debugging */}
                        <KnowledgeBot />
                    </div>
                </div>
            )}
            
        </div>
    );
};

export default MobileLanding;
